<template>
  <div class="doc">
    <MDPage path="/docs.md"></MDPage>
  </div>
</template>

<script>

import MDPage from '@/components/MDPage.vue'
export default {
  components: {
    MDPage
  }
}
</script>

<style scoped>
  .doc {
      /* margin-left:3em;
      margin-right:3em; */
      text-align: left;
  }
</style>

